import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "-text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "-number" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "-unit" }, "件", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "-text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "-number" }, "0"),
  /*#__PURE__*/_createElementVNode("span", { class: "-unit" }, "件")
], -1)

import { getCountApplyListService } from '@/api/services/shintyokuService';
import { onActivated, onMounted, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyWidget',
  props: {
    classPrefix: null,
    isFromApply: { type: Boolean },
    isJobListLoaded: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  classPrefix: string;
  isFromApply?: boolean;
  isJobListLoaded?: boolean;
}

const applyStatistics = ref<Array<{
  name: string;
  count: number;
  query: string;
}>>([
  {
    name: '書類準備中',
    count: 0,
    query: 'documentInPreparationCount'
  },
  {
    name: '書類選考',
    count: 0,
    query: 'documentScreeningCount'
  },
  {
    name: '面接',
    count: 0,
    query: 'interviewCount'
  },
  {
    name: '内定',
    count: 0,
    query: 'jobOfferCount'
  },
]);



const loadApplyCountData = async () => {
  const applyCountData = (await getCountApplyListService()) as { [key: string]: number };
  if (applyCountData) {
    applyStatistics.value.forEach((item) => {
      item.count = applyCountData[item.query] ?? 0;
    });
  }
}

const route = useRoute();
onActivated(async () => {
  if(route.meta.isBack && props.isJobListLoaded) return;

  await loadApplyCountData();
});

onMounted(async () => {
  if(props.isFromApply) return;

  await loadApplyCountData();
});

expose({
  applyStatistics,
  loadApplyCountData,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${__props.classPrefix}-dashboard`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`${__props.classPrefix}-headingBlock`)
    }, [
      (_ctx.$slots.header)
        ? _renderSlot(_ctx.$slots, "header", { key: 0 })
        : (_openBlock(), _createElementBlock("h1", {
            key: 1,
            class: _normalizeClass(`${__props.classPrefix}-headingLv1`)
          }, "応募管理", 2))
    ], 2),
    _createElementVNode("ul", {
      class: _normalizeClass(`${__props.classPrefix}-dashboard_list`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyStatistics.value, (ast) => {
        return (_openBlock(), _createElementBlock("li", {
          key: ast.query,
          class: _normalizeClass({[__props.classPrefix + '-dashboard_item']: true, '-empty': ast.count == 0})
        }, [
          (ast.count > 0)
            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                key: 0,
                to: { name: 'n00', query: {k: ast.query} }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(ast.name), 1),
                  _hoisted_2,
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(ast.count), 1),
                    _hoisted_4
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(ast.name), 1),
                _hoisted_7,
                _hoisted_8
              ]))
        ], 2))
      }), 128))
    ], 2)
  ], 2))
}
}

})